export const MessageSources = {
  AGENT: "AGENT",
  BOT: "BOT",
  CUSTOMER: "CUSTOMER",
  SYSTEM: "SYSTEM",
};

export const SuggestionType = {
  TEXT: "TEXT",
  ATTACHMENT: "ATTACHMENT",
};


export const FormMessageKeys = {
  VIEWNAME: "viewName",
  IMAGEID: "imageId",
  MOBILENUMBER: "mobileNumber",
  STARTDATETIME: "startDateTime",
  ENDDATETIME: "endDateTime",
  QUERY: "query",
};


